import debounce from 'lodash/debounce';
import { makeAutoObservable, action } from 'mobx';
import { fetchLocations } from '../api/SlmService';

class LocationServiceStore {

  locationQueryCache = {};

  locations = null;

  didError = false;

  isFetching = false;

  constructor() {
    makeAutoObservable(this);
  }

  updateIsFetching = (isFetching) => {
    this.isFetching = isFetching;
  };

  getLocations = (query, mandateZip) => {
    return this._fetchLocation(query, mandateZip);
  };

  _getFromCache = (query) => {
    return this.locationQueryCache[query];
  };

  _updateCache = (query, results) => {
    this.locationQueryCache[query] = results;
  };

  _updateLocations = action((locations) => {
    this.locations = locations?.locationDisplays || [];
  });

  clearLocations = action(() => {
    this.locations = null;
  });

  _fetchLocation = debounce(async (query, mandateZip) => {

    try {
      let locations = await fetchLocations(query, mandateZip);
      this._updateCache(query, locations);
      this._updateLocations(locations);
      return locations;
    } catch (err) {
      this.didError = true;
      console.log(err);
    }
  }, 250);
  // not using currently but leaving it in here for when we implement proximity search

  _getUserLocation = () => {
    if (navigator?.geolocation) {

      navigator.geolocation.getCurrentPosition(
        ({ coords }) => {
          this.userLocation = {
            latitude: coords.latitude,
            longitude: coords.longitude
          };
        }, function handleError(e) {
          console.log(e);
        });
    }
    return this._fetchLocation(this.userLocation);
  };
}

export default new LocationServiceStore();
